import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, EMPTY, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AntifraudNoticeService } from '../shared/services/util/antifraud-notice.service';

@Injectable()
export class AntifraudHttpInterceptor implements HttpInterceptor {
    constructor(private readonly antifraudNoticeService: AntifraudNoticeService) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            mergeMap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (this.isPendingBody(event.body)) {
                        this.antifraudNoticeService.showPending();
                        return EMPTY;
                    }
                }
                return of(event);
            }),
            catchError((error: HttpErrorResponse) => {
                if (this.isPendingError(error)) {
                    this.antifraudNoticeService.showPending();
                    return EMPTY;
                }

                if (this.isBlockedError(error)) {
                    this.antifraudNoticeService.showBlocked();
                    return EMPTY;
                }

                return throwError(error);
            })
        );
    }

    private isPendingBody(body: any): boolean {
        return body?.error === 'TRANSACTION_PENDING_APPROVAL'
            || body?.message === 'TRANSACTION_PENDING_APPROVAL';
    }

    private isPendingError(error: HttpErrorResponse): boolean {
        return error?.error?.error === 'TRANSACTION_PENDING_APPROVAL'
            || error?.error?.message === 'TRANSACTION_PENDING_APPROVAL'
            || error?.status === 202;
    }

    private isBlockedError(error: HttpErrorResponse): boolean {
        const code = error?.error?.error;
        if (code === 'TRANSACTION_BLOCKED') return true;

        const msg = error?.error?.message;
        if (msg === 'TRANSACTION_BLOCKED') return true;

        const message = String(msg || error?.message || '')?.toLowerCase();
        return message.includes('transaction blocked') || message.includes('antifraud');
    }
}
